(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const deliveryDateInput = document.getElementById('delivery-date');
    const deliveryTimeSelect = document.getElementById('delivery-time');

    function updateCartAttributes() {
      const date = deliveryDateInput ? deliveryDateInput.value : '';
      const time = deliveryTimeSelect ? deliveryTimeSelect.value : '';
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: {
            '希望配送日': date,
            '希望配送時間帯': time
          }
        })
      });
    }

    if (deliveryDateInput) {
      deliveryDateInput.addEventListener('change', updateCartAttributes);
    }
    if (deliveryTimeSelect) {
      deliveryTimeSelect.addEventListener('change', updateCartAttributes);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
